import React, { useEffect } from 'react';
import './App.css';
import './styles/darkMode.css';
import AppProviders from './app/providers.tsx';
import AppRoutes from './app/routes.tsx';
import { applyFlavorBranding } from './shared/config/flavorConfig';

function App() {
  useEffect(() => {
    applyFlavorBranding();
  }, []);

  return (
    <AppProviders>
      <AppRoutes />
    </AppProviders>
  );
}

export default App;
